import { initContentUi } from "../modules/content-ui.js";
jQuery(($) => initContentUi($));
